import { render, staticRenderFns } from "./lawsarticl.vue?vue&type=template&id=24af3834&scoped=true&"
import script from "./lawsarticl.vue?vue&type=script&lang=js&"
export * from "./lawsarticl.vue?vue&type=script&lang=js&"
import style0 from "./lawsarticl.vue?vue&type=style&index=0&id=24af3834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24af3834",
  null
  
)

export default component.exports